"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIPopoverHeader;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _UIPopoverCloseButton = _interopRequireDefault(require("./UIPopoverCloseButton"));

var _PopoverContext = require("../context/PopoverContext");

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n            border-top-right-radius: ", ";\n            border-top-left-radius: ", ";\n            color: ", ";\n            padding: ", " ", ";\n          "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n\n  && {\n    background: ", ";\n    ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Header = _styledComponents.default.header.withConfig({
  displayName: "UIPopoverHeader__Header",
  componentId: "sc-14lxrwv-0"
})(_templateObject(), function (_ref) {
  var popoverUse = _ref.popoverUse;
  return popoverUse === 'shepherd' ? _colors.THUNDERDOME : 'inherit';
}, function (_ref2) {
  var popoverUse = _ref2.popoverUse;
  return popoverUse === 'shepherd' ? (0, _styledComponents.css)(_templateObject2(), _sizes.BUTTON_RADIUS, _sizes.BUTTON_RADIUS, _colors.OLAF, _sizes.SHEPHERD_PADDING_Y, _sizes.POPOVER_PADDING_X) : null;
});

function UIPopoverHeader(_ref3) {
  var className = _ref3.className,
      children = _ref3.children,
      flush = _ref3.flush,
      onOpenChange = _ref3.onOpenChange,
      showCloseButton = _ref3.showCloseButton,
      rest = (0, _objectWithoutProperties2.default)(_ref3, ["className", "children", "flush", "onOpenChange", "showCloseButton"]);
  var popoverUse = (0, _react.useContext)(_PopoverContext.PopoverContext).use;
  return _react.default.createElement(Header, (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('uiPopoverHeader', 'private-popover__header', {
      'private-popover__header--flush': flush
    }, className),
    popoverUse: popoverUse
  }), children, showCloseButton && _react.default.createElement(_UIPopoverCloseButton.default, {
    popoverUse: popoverUse,
    onClick: function onClick() {
      if (onOpenChange) onOpenChange((0, _SyntheticEvent.default)(false));
    }
  }));
}

UIPopoverHeader.propTypes = {
  children: _propTypes.default.node,
  flush: _propTypes.default.bool,
  showCloseButton: _propTypes.default.bool,
  onOpenChange: _propTypes.default.func
};
UIPopoverHeader.displayName = 'UIPopoverHeader';
module.exports = exports.default;